module.exports = __webpack_public_path__ + "static/media/hab10-1.0fe16d1e.jpg";